module.exports = __webpack_public_path__ + "img/24.01a010c7.jpg";